var _ListItem, _Divider;
import * as React from 'react';
import { Divider, ListItem, ListItemText, Skeleton, Stack } from '@lumahealthhq/ui-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ListAvailabilitiesByFacility(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsxs(Stack, {
    gap: 3,
    children: [_ListItem || (_ListItem = /*#__PURE__*/_jsx(ListItem, {
      disableGutters: true,
      disablePadding: true,
      children: /*#__PURE__*/_jsx(ListItemText, {
        primary: /*#__PURE__*/_jsx(Skeleton, {
          width: "140px",
          height: "32px"
        }),
        secondary: /*#__PURE__*/_jsx(Skeleton, {
          width: "240px",
          height: "24px"
        })
      })
    })), _Divider || (_Divider = /*#__PURE__*/_jsx(Divider, {})), /*#__PURE__*/_jsx(Stack, {
      gap: 3,
      children: children
    })]
  });
}